import ApplicationController from '../application_controller'
import { enableElements, disableElements } from '../../lib/elements_helper'

class ExportEmployeeController extends ApplicationController {
  static targets = ['target_system', 'download', 'send', 'unitId']

  connect () {
    this.setParameters()
    this.select_box()
  }

  select_box (event) {
    if (this.requiredFields()) {
      this.setParameters()

      enableElements(...this.buttonsList())
    } else {
      disableElements(...this.buttonsList())
    }
  }

  requiredFields () {
    return this.unitIdTarget.selectedIndex > 0 &&
      this.target_systemTarget.selectedIndex > 0
  }

  setParameters () {
    const href = new URL(this.downloadTarget.href)
    href.searchParams.set('unit_id', this.unitIdTarget.value)
    href.searchParams.set('target', this.target_systemTarget.value)
    this.downloadTarget.href = href
  }

  buttonsList () {
    const buttons = [this.downloadTarget]
    if (this.hasSendTarget) {
      buttons.push(this.sendTarget)
    }

    return buttons
  }
}

export default ExportEmployeeController
